import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { CallTypeInterface } from '../../../../core/interfaces/call-type.interface';
import { PayorInterface } from '../../../../core/interfaces/payor.interface';
import { ResponseInterface } from '../../../../core/interfaces/response.interface';
import { RiderPayorDetailInterface } from '../../../../core/interfaces/rider-payor-detail.interface';
import { RiderPayorInterface } from '../../../../core/interfaces/rider-payor.interface';
import { RiderInterface } from '../../../../core/interfaces/rider.interface';
import { CallTypeService } from '../../../../core/services/call-type.service';
import { PayorService } from '../../../../core/services/payor.service';
import { RiderService } from '../../../../core/services/rider.service';
import { T2LoadingService } from '../../../../trip2-theme/components/t2-loading/t2-loading.service';
import { ParentModule } from '../../../A2-utils/ParentClass/parent-module';
import { T2CardComponent } from '../../../../trip2-theme/components/t2-card/t2-card.component';
import { assignNewObjet } from '../../../A2-utils/export-functions/functions-services';
import { SweetAlertHelper } from '../../../../core/helpers/sweet-alert-helper.service';
import { DataProcessingService } from 'app/pages/data-processing/data-processing.service';
import { SsnService } from 'app/utils/ssn-module/ssn.service';
import { RiderNotesInformationService } from 'app/core/services/rider-notes-information.service';
import { EmailValidationRule } from '../../../A2-utils/ParentClass/additional-rules';
import { RoleEnum } from 'app/core/enums/role.enum';
import { RiderSubTabsEnum, RiderTabsEnum } from 'app/core/enums/tabs-rider.enum';

@Component({
  selector: 'app-rider-form',
  templateUrl: './rider-form.component.html',
  styleUrls: ['./rider-form.component.scss']
})

export class RiderFormComponent extends ParentModule implements OnInit, OnChanges, OnDestroy {
  private subscriptions: Subscription[] = [];
  @ViewChild('showError') showError: T2CardComponent;
  @ViewChild('modalNote') ModalNote: T2CardComponent;
  @Input() riderId: number;
  @Output() eventEmitterRiderForm: EventEmitter<any>= new EventEmitter<any>();
  @Output() titleCard?: EventEmitter<string>= new EventEmitter<string>();
  @Output() closeForm?: EventEmitter<boolean>= new EventEmitter<boolean>();
  @Input() actionsComp: boolean;
  protected form: FormGroup;
  protected callTypes: Observable<CallTypeInterface[]>;
  protected payors: Observable<PayorInterface[]>;
  /*protected rider: Observable<RiderInterface>;*/
  protected tabs = RiderTabsEnum.RiderDetails;
  public accountsToMerge = [];
  public errorModal = false;
  public riderInfo: RiderInterface;
  public isSuspendedModel: boolean;
  public isUnableToSign: boolean;
  public isSavedNote: boolean;
  subTabs = RiderSubTabsEnum.RiderPayor;
  riderTabsEnum = RiderTabsEnum;
  riderSubTabsEnum = RiderSubTabsEnum;
  private currentUser: any = JSON.parse(localStorage.getItem('currentUser'));

  constructor(
    private _loadingT2: T2LoadingService,
    private fb: FormBuilder,
    private _callTypeService: CallTypeService,
    private _riderService: RiderService,
    private _payorService: PayorService,
    protected Inject: Injector,
    private sweetAlertHelper: SweetAlertHelper,
    private dataProcessingService: DataProcessingService,
    private ssnService: SsnService,
    protected riderNoteService: RiderNotesInformationService
  ) {
    super('app-rider-form', Inject);
    this.createRiderForm();
  }

  ngOnInit() {
    this.callTypes = this._callTypeService.get();
    const showInactive = this.validateAdminUser;
    this.payors = this._payorService.get(showInactive);

    if (this.form) {
      const additionalRules = [EmailValidationRule];
      this.applyRules(this.form, this.riderId !== 0 ? 'Update' : 'Create', additionalRules);
    }

    if (this.riderId !== 0) {
      this.loadRider(this.riderId);
    }else {
      setTimeout(() => {
        this.titleCard.emit('New Rider');
      }, 1000);

    }
  }

  get validateAdminUser(): boolean {
    return this.currentUser && this.currentUser.roleid === RoleEnum.Admin;
  }

  ngOnChanges(changes: SimpleChanges): void {
    // this.riderId = 871034;//TODO delete id test module edit riderPayo
    // this.loadRider(this.riderId);
    // if (changes['addNewRider']) {
    //   if (!this.addNewRider) {
    //     this.tabs = 0;
    //     this.resetForm();
    //   } else {
    //     if (this.riderId != 0){
    //       this.loadRider(this.riderId);
    //     }
    //   }
    // }
  }

  resetForm(): void {
    while (this.riderPayorArray.length !== 0) {
      this.riderPayorArray.removeAt(0);
    }
  }

  loadRider(riderId?: number) {
    this.resetForm();
    this._loadingT2.show('Loading Rider Information...');
    if (riderId != 0 || this.riderId != 0) {
      this.subscriptions.push(
        this._riderService.get(riderId ? riderId : this.riderId, true )
          .finally(() => this._loadingT2.hiden())
          .subscribe((resp: RiderInterface) => {
            this.modifyDateValue(resp, true);
            this.titleCard.emit('Edit Rider ' + resp.fullname);

            const provideIdRider = resp.providerid ? resp.providerid : null;
            resp.providerid = provideIdRider;
            this.form.patchValue(resp);
            this.addFbGroupArray(resp.riderpayors);
            this.riderInfo = assignNewObjet(resp);
            this._riderService.getDataRider(resp);
            this.isSuspendedModel = this.form.get('issuspended').value;
            this.isUnableToSign = this.form.get('unabletosign').value;
          })
      );
    }
  }

  /**@name modifyDateValue
   * @description para modificar formato de fecha - to modify date format
   * */
  private modifyDateValue(value: Object, entry: boolean): void {
    if (entry) {
      if (value['dobformatted']) {
        value['dob'] = value['dobformatted'];
      }
      if (value['dodformatted']) {
        value['dod'] = value['dodformatted'];
      }
    }else {
      if (value['dob']) {
        value['dob'] = value['dob'];
      }
      if (value['dod']) {
        value['dod'] = value['dod'];
      }
    }
  }

  loadRiderPayor($event: any, riderId?: number) {
    if ($event) {
      this.resetForm();
      this._loadingT2.show('Loading Rider Payor...');
      this.subscriptions.push(
        this._riderService.get(riderId ? riderId : this.riderId)
          .finally(() => this._loadingT2.hiden())
          .subscribe((resp) => {
            this.eventEmitterRiderForm.emit(resp);
            this.addFbGroupArray(resp.riderpayors);
          })
      );
    }
  }

  addFbGroupArray(riderPayor: RiderPayorInterface[]) {
    if (riderPayor != null) {
      riderPayor.forEach((y) => {
        this.riderPayorArray.push(this.fb.group({
          // enableplans: y.enableplans,
          riderid: y.riderid,
          payorid: y.payorid,
          riderpayorid: y.riderpayorid,
          description: y.payor.description,
          memberid: y.memberid,
          isactive: y.isactive,
          isdefault: y.isdefault,
          medicaidnumber: y.medicaidnumber,
          riderpayordetails: this.addFbArray(y.riderpayordetails)
        }));
      });
    }

  }

  addFbArray(riderPayorDetail: RiderPayorDetailInterface[]) {
    let a = new FormArray([]);
    if (riderPayorDetail != null) {
      riderPayorDetail.forEach(x => {
        a.push(this.addFbGroup({
          riderpayordetailid: x.riderpayordetailid,
          riderpayorid: x.riderpayorid,
          groupid: x.groupid,
          startdate: x.startdateformatted,
          expirationdate: x.expirationdateformatted,
          planid: x.planid,
          isltc: x.isltc,
          tripsqty: x.tripsqty,
          createdon: x.createdon,
          modifiedonformatted: x.modifiedonformatted
        }));
      });
      return a;
    } else {
      return a;
    }
  }

  addFbGroup(json) {
    return this.fb.group(json);
  }

  get riderPayorArray(): FormArray {
    return this.form.get('riderpayors') as FormArray;
  }

  private createRiderForm() {
    this.form = this.fb.group({
      // Rider Personal Info
      _roleid               : '',
      isvip                 : false,
      fullname              : '',
      lastname              : '',
      firstname             : '',
      middleinitial         : '',
      ssn                   : [null],
      dob                   : '',
      dod                   : '',
      gender                : '',
      calltypeid            : '',
      email                 : '',
      phonenumber           : '',
      alternatephonenumber  : '',
      providerid            : '',
      depotid               : '',
      driveid               : '',
      driverid              : '',
      vipon                 : '',
      // End Rider Personal Info


      // IVR Info
      _activeIVRTab         : '',
      sendsms               : '',
      sendmail              : '',
      virtualagent          : '',
      makephonecall         : '',
      ivrstatus             : '',

      // Location
      streetaddress         : '',
      location              : '',
      city                  : '',
      state                 : '',
      zip                   : '',
      latitude              : '',
      longitude             : '',
      county                : '',
      roomaptnumber         : '',
      pstreetaddress        : '',
      plocation             : '',
      proomaptnumber        : '',
      pcity                 : '',
      pstate                : '',
      pzip                  : '',
      pphone                : '',
      platitude             : '',
      plongitude            : '',
      pcounty               : '',
      _permatentResidence   : '',

      manualcoordinates     : false,
      ismanualaddress       : false,
      pmanualcoordinates    : false,
      ismanualpaddress      : false,

      _selectedDefaultPayor : '',
      riderid               : '',

      isinactive            : '',
      preferredlanguage     : '',
      isfacility            : '',
      defaultpayor          : '',
      defaultpayorid        : '',
      policy                : '',
      dobformatted          : '',
      address               : '',
      addedon               : '',
      modifiedon            : '',
      issuspended           : '',
      unabletosign          : '',
      requestedbyid         : null,
      emailverified         : false,

      // Rider Payor Info
      riderpayors: this.fb.array([]),
      // Rider Payor Info
    });
  }

  validatePhone(form): boolean {
    if (form) {
      let sw = false;
      Object.keys(form).forEach((item) => {
        if (item === 'alternatephonenumber' || item === 'phonenumber') {
          const validPhone = this.verifyLengthPhone(this.form.get(item).value);
          if (validPhone) {
            sw = validPhone;
          };
        }
      });
      return sw;
    }
  }

  verifyLengthPhone(phone: string): boolean {
    const phoneValid = phone.replace(/[^0-9]/g, '').length;
    if (phone && phoneValid < 10) {
      this.sweetAlertHelper.createCustomAlert({ title: 'Invalid Phone Number', text: '', type: 'error' });
      return true;
    }
    return false;
  }

  save() {
    if (!this.form.valid) {
      this.sweetAlertHelper.createCustomAlert({
        title: 'Please complete the form correctly',
        type: 'error',
      });
      return;
  }
    if (this.form.get('riderpayors').value.length) {
      this._loadingT2.show('Processing Request...');
      const value = this.form.getRawValue();
      if (this.validatePhone(value)) {
        this._loadingT2.hiden();
        return;
      }
      this.modifyDateValue(value, false);
      const shouldCaptureException =
      value &&
      value.ivrstatus === IvrStatusEnum.OptIn &&
      !value.makephonecall &&
      !value.sendmail &&
      !value.sendsms &&
      !value.virtualagent;
      if (shouldCaptureException) {
        this.sweetAlertHelper.captureException('Please select at least one Opt-in option');
        this._loadingT2.hiden();
        return;
      }
      if (this.riderId !== 0 || value.riderid) {
        value.riderpayors = [];
        this.subscriptions.push(
          this._riderService.put(value)
            .finally(() => {
              this.ssnService.disabledInput.emit(true);
              this._loadingT2.hiden();
            })
            .subscribe(resp => {
              this.eventEmitterRiderForm.emit(resp);
              this.sweetAlertHelper.createCustomAlert({
                position: 'top-end',
                type: 'success',
                title: 'Updated Success!',
                showConfirmButton: false,
                timer: 1500
              });
              if (value.isinactive) {
                this.closeForm.emit(true);
              }
              this.dataProcessingService.getReloadGrid(true);
            },
            (error: ResponseInterface) => {
              this.sweetAlertHelper.captureException(error);
            })
        );
      } else {
        this.subscriptions.push(
          this._riderService.post(value)
            .finally(() => {
              this._loadingT2.hiden();
              this.ssnService.disabledInput.emit(true);
            })
            .subscribe(resp => {
              this.riderId = resp.data;
              this.loadRider(resp.data);
              this.eventEmitterRiderForm.emit(resp);
              this.sweetAlertHelper.createCustomAlert({
                position: 'top-end',
                type: 'success',
                title: 'Saved Successfully!',
                showConfirmButton: false,
                timer: 1500
              });
            }, (error) => {
              this.sweetAlertHelper.captureException(error);
            })
        );
      }
    } else {
      alert('Please add at least one Payor.');
    }
  }

  private swal(type: string, resp?: ResponseInterface, msj?: string) {
    this.errorModal = true;
    this.showError.open();
  }

  emitterActionCard($event){

  }

  checkInactive(event) {
    const changeInactive = event.currentTarget.checked;
    let textMsg = '';
    changeInactive ? textMsg = 'inactivate' : textMsg = 'activate';
    this.sweetAlertHelper.createCustomAlert({
      title: `Are you sure you want to ${textMsg} this rider?`,
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: `Yes, ${textMsg} it!`
    }).then((result) => {
      if (result.value) {
        this.save();
      } else {
        this.form.get('isinactive').setValue(!this.isInactive);
      }
    })
  }


  get isInactive(): boolean {
    return this.form.get('isinactive').value;
  }

  closeModal(close: boolean): void {
    if (close) {
      this.ModalNote.close();
    }
  }

  emitModalVisible(event: { isOpen: boolean }): void {
    if (event && !event.isOpen && !this.isSavedNote) {
      if (this.isSuspendedModel !== this.form.get('issuspended').value) {
        this.form
          .get('issuspended')
          .patchValue(!this.form.get('issuspended').value);
      }
      if (this.isUnableToSign !== this.form.get('unabletosign').value) {
        this.form
          .get('unabletosign')
          .patchValue(!this.form.get('unabletosign').value);
      }
    }
  }

  savedSuccessfully(event: { message: string; success: boolean }): void {
    if (event && event.success) {
      this.isSavedNote = true;
      this.ModalNote.close();
      this.riderNoteService.changeNotes.next(true);
      this.save();
    } else {
      this.sweetAlertHelper.createCustomAlert({
        title: 'Error when note is created',
        type: 'error',
        showConfirmButton: false,
        timer: 1500,
      });
    }
  }

  openModalNote() {
    this.isSavedNote = false;
    const isSuspended = this.form.get('issuspended').value;
    this.sweetAlertHelper
      .createCustomAlert({
        title: `Are you sure to you want  ${
          isSuspended ? 'suspended' : 'enable'
        } this member?`,
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Accept',
        cancelButtonText: 'Cancel',
      })
      .then((result) => {
        if (result.value) {
          this.ModalNote.open();
        } else {
          this.form
            .get('issuspended')
            .patchValue(!this.form.get('issuspended').value);
        }
      });
  }

  openModalNoteUnableToSign() {
    this.isSavedNote = false;
    this.sweetAlertHelper
      .createCustomAlert({
        title: 'Are you sure to perform this action?',
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Accept',
        cancelButtonText: 'Cancel',
      })
      .then((result) => {
        if (result.value) {
          this.ModalNote.open();
        } else {
          this.form
            .get('unabletosign')
            .patchValue(!this.form.get('unabletosign').value);
        }
      });
  }

  getValidTabs(tab: number): boolean {
    return this.tabs === tab;
  }

  getValidSubTabs(tab: number): boolean {
    return this.subTabs === tab;
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

}

const enum IvrStatusEnum {
  None = 0,
  OptIn = 1,
  OptOut = 2
}



// WEBPACK FOOTER //
// ./src/app/pages/rider/components/rider-form/rider-form.component.ts